module.exports = __webpack_public_path__ + "img/testimonials-icon-red.84938886.svg";